import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiCall } from "services/api";

export const getMyAssigments = createAsyncThunk(
  "/assignments/my",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall().get("/my/assignments");

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getWorkspaceAssigments = createAsyncThunk(
  "/assignments/workspace",
  async (workspaceId: number, { rejectWithValue }) => {
    try {
      const response = await apiCall().get(`/my/assignments/${workspaceId}`);

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);
